import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function CampaignIntelligenceIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 40 40" fill="none" {...props}>
      <Box
        as="path"
        fill="currentColor"
        fillRule="evenodd"
        d="M12.983 5a3.959 3.959 0 0 1 3.959 3.958v4.646a3.96 3.96 0 0 1 1.041-.142h3.609a4.376 4.376 0 0 1 4.375 4.375v4.227a3.96 3.96 0 0 1 1.042-.142h4.024a3.96 3.96 0 0 1 3.959 3.959v5.152a3.96 3.96 0 0 1-3.958 3.959H8.957A3.96 3.96 0 0 1 5 31.034V8.957A3.96 3.96 0 0 1 8.958 5h4.025ZM8.958 7.917c-.574 0-1.041.467-1.041 1.041v22.075c0 .575.467 1.042 1.041 1.042h5.067V8.958c0-.575-.466-1.041-1.042-1.041H8.958Zm9.025 8.462c-.574 0-1.04.467-1.041 1.041v14.655h6.108V17.837c0-.805-.653-1.458-1.458-1.458h-3.609Zm9.026 8.46c-.575 0-1.042.467-1.042 1.042v6.194h5.067c.574 0 1.04-.467 1.041-1.042v-5.152c0-.575-.467-1.042-1.042-1.042H27.01Z"
        clipRule="evenodd"
      />
      <Box
        as="path"
        fill="currentColor"
        d="M29.063 5.874c.25-1.165 1.913-1.165 2.164 0l.124.571a2.878 2.878 0 0 0 2.209 2.209l.57.122c1.166.251 1.166 1.915 0 2.166l-.57.123a2.879 2.879 0 0 0-2.21 2.208l-.123.571c-.25 1.165-1.914 1.165-2.165 0l-.123-.57a2.878 2.878 0 0 0-2.209-2.21l-.57-.122c-1.164-.25-1.164-1.915 0-2.166l.57-.122a2.878 2.878 0 0 0 2.209-2.209l.123-.571Z"
      />
    </Icon>
  );
}
